import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getProveedores,
  deleteProveedor,
  getProveedorById,
} from "../helpers/rutaProveedores";
import ModalProveedor from "./ModalProveedor";
import "../css/tableproveedores.css";

const COLS = {
  acciones: 100,
  nro: 70,
  razon: 220,
  domicilio: 180,
  telefono: 140,
  cuit: 140,
  email: 220,
  localidad: 160,
  iva: 140,
};

const cellTruncate = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const TableProveedores = () => {
  const [state, setState] = useState({
    proveedores: [],
    loading: true,
    error: "",
  });

  const [proveedor, setProveedor] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaProveedores();
  }, []);

  const consultaProveedores = async () => {
    try {
      const datos = await getProveedores(0, 1000); // ← usa ?desde=0&limite=1000
      const list = Array.isArray(datos) ? datos : [];
      list.sort((a, b) =>
        (a?.razonsocial || "").localeCompare(b?.razonsocial || "", "es", { sensitivity: "base" })
      );
      setState({ proveedores: list, loading: false, error: "" });
    } catch (e) {
      setState((s) => ({ ...s, loading: false, error: e?.message || "Error al cargar proveedores" }));
      console.error("❌ getProveedores:", e);
    }
  };


  const handleClose = () => {
    setShow(false);
    consultaProveedores();
  };
  const handleShow = () => setShow(true);

  const modificaProveedor = async (id) => {
    try {
      const resp = await getProveedorById(id);
      // backend: GET /proveedores/:id → { ok, proveedores:{...} }
      // (y en POST/PUT/DELETE suele venir { proveedor:{...} })
      setProveedor(resp?.proveedores || resp?.proveedor || resp || null);
      handleShow();
    } catch (e) {
      console.error("❌ getProveedorById:", e);
      alert("No se pudo abrir el proveedor.");
    }
  };

  const onDelete = async (id) => {
    if (!window.confirm("¿Está seguro que desea borrar el proveedor?")) return;
    try {
      await deleteProveedor(id);
      consultaProveedores();
    } catch (e) {
      console.error("❌ deleteProveedor:", e);
      alert("No se pudo borrar el proveedor.");
    }
  };

  if (state.loading) return <div className="p-3">Cargando proveedores…</div>;
  if (state.error) return <div className="p-3 text-danger">{state.error}</div>;

  const rows = state.proveedores.filter((p) => p?.activo ?? true);

  return (
    <div className="table-container">
      <div className="col-12 mt-4" />
      <div>
        <Table
          striped
          bordered
          hover
          className="table-container"
          style={{ tableLayout: "fixed", width: "100%" }}
        >
          <thead>
            <tr className="header">
              <th style={{ width: COLS.acciones }}>Modif/Elim</th>
              <th style={{ width: COLS.nro }}>Nro</th>
              <th style={{ width: COLS.razon}}>Razón Social</th>
              <th style={{ width: COLS.domicilio }}>Domicilio</th>
              <th style={{ width: COLS.telefono }}>Teléfono</th>
              <th style={{ width: COLS.cuit }}>CUIT</th>
              <th style={{ width: COLS.email }}>Email</th>
              <th style={{ width: COLS.localidad }}>Localidad</th>
              {/* <th style={{ width: COLS.iva }}>Cond IVA</th> */}
            </tr>
          </thead>

          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={9} className="text-center">
                  No hay proveedores.
                </td>
              </tr>
            ) : (
              rows.map((p) => (
                <tr key={p._id}>
                  <td style={{ width: COLS.acciones, whiteSpace: "nowrap" }}>
                    <div
                      style={{
                        display: "flex",
                        gap: 8,
                        flexWrap: "nowrap",
                        justifyContent: "center",
                      }}
                    >
                      <button className="btn btn-primary" onClick={() => modificaProveedor(p._id)}>
                        <i className="fa fa-pencil-square-o" aria-hidden="true" />
                      </button>
                      <button className="btn btn-danger" onClick={() => onDelete(p._id)}>
                        <i className="fa fa-trash-o" aria-hidden="true" />
                      </button>
                    </div>
                  </td>

                  <td style={{ width: COLS.nro }}>{p.codprov}</td>
                  <td style={{ width: COLS.razon, textAlign: "left", ...cellTruncate }}>{p.razonsocial}</td>
                  <td style={{ width: COLS.domicilio, textAlign: "left", ...cellTruncate }}>{p.domicilio}</td>
                  <td style={{ width: COLS.telefono }}>{p.telefono}</td>
                  <td style={{ width: COLS.cuit }}>{p.cuit}</td>
                  <td style={{ width: COLS.email, ...cellTruncate }}>{p.email}</td>
                  <td style={{ width: COLS.localidad, ...cellTruncate }}>{p.localidad?.localidad || "-"}</td>
                  {/* <td style={{ width: COLS.iva, ...cellTruncate }}>{p.condicioniva?.iva || "-"}</td> */}
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>

      <ModalProveedor show={show} handleClose={handleClose} proveedor={proveedor} />
    </div>
  );
};

export default TableProveedores;
